import gsap from "gsap";
import Controller from "./scrollmagic/controller";
import Scrollbar from "smooth-scrollbar";
var ScrollController = /** @class */ (function () {
    function ScrollController(options) {
        var _this = this;
        this.scenes = [];
        this.scrollbarListeners = [];
        this.isScrollingTo = false;
        this.options = options;
        this.container = options.container || window;
        this.smoothScrolling = options.smoothScrolling || false;
        // Scroll to when loading page with hashtag
        // https://github.com/idiotWu/smooth-scrollbar/issues/128#issuecomment-390980479
        var hash = location.hash;
        if (hash) {
            requestAnimationFrame(function () {
                setTimeout(function () {
                    var _a;
                    (_a = _this.container) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
                    if (_this.smoothScrolling) {
                        var elem = document.querySelector(hash);
                        if (elem) {
                            _this.scrollbar.scrollIntoView(elem, {
                                offsetTop: -_this.scrollbar.containerEl.scrollTop,
                            });
                        }
                    }
                    else {
                        _this.controller.scrollTo(hash);
                    }
                }, 0);
            });
        }
    }
    Object.defineProperty(ScrollController.prototype, "smoothScrolling", {
        get: function () {
            return this._smoothScrolling;
        },
        set: function (newValue) {
            this.removeAllScenes();
            this.destroyController();
            this._smoothScrolling = newValue;
            if (this._smoothScrolling) {
                console.debug("[ScrollController] Smooth scrolling activated");
                this.controller = new Controller(Object.assign(this.options, { smoothScrolling: true, refreshInterval: 0 }));
                this.createScrollbars();
            }
            else {
                console.debug("[ScrollController] Common scrolling activated");
                this.controller = new Controller(this.options);
                this.controller.scrollTo(function (newPos) {
                    gsap.to(this, {
                        duration: 2,
                        scrollTo: {
                            y: newPos,
                        },
                        ease: "power4.out",
                    });
                });
                this.removeScrollbars();
            }
            this.addAllScenes();
        },
        enumerable: false,
        configurable: true
    });
    ScrollController.prototype.scrollTo = function (targetId) {
        var _this = this;
        if (this.smoothScrolling) {
            var element = this.container instanceof Window
                ? document.body.querySelector(targetId)
                : this.container.querySelector(targetId);
            if (element) {
                this.scrollbar.scrollIntoView(element);
            }
        }
        else {
            this.latestTargetId = targetId;
            this.isScrollingTo = true;
            this.controller.scrollTo(targetId, function () {
                _this.isScrollingTo = false;
            });
        }
    };
    ScrollController.prototype.getScrollPos = function () {
        if (this.smoothScrolling) {
            return this.scrollbar.offset.y;
        }
        return this.controller.scrollPos();
    };
    ScrollController.prototype.addScene = function (scene) {
        scene.addTo(this);
        this.scenes.push(scene);
    };
    ScrollController.prototype.removeScene = function (scene) {
        scene.remove();
        this.scenes = this.scenes.filter(function (current) {
            return current !== scene;
        });
    };
    ScrollController.prototype.addScrollbarListener = function (listener) {
        if (this.scrollbar) {
            this.scrollbar.addListener(listener);
            this.scrollbarListeners.push(listener);
        }
    };
    ScrollController.prototype.removeScrollbarListener = function (listener) {
        if (this.scrollbar) {
            this.scrollbar.removeListener(listener);
            this.scrollbarListeners = this.scrollbarListeners.filter(function (current) {
                return current !== listener;
            });
        }
    };
    ScrollController.prototype.setScrollOffset = function (offset) {
        if (!this._smoothScrolling) {
            this.controller.scrollTo(function (newPos, callback) {
                gsap.to(this, {
                    duration: 2,
                    scrollTo: {
                        y: newPos + offset,
                    },
                    onComplete: function () {
                        if (callback)
                            callback();
                    },
                    ease: "power4.out",
                });
            });
            // This is necessary because if the offset changes while the page is animating,
            // it goes to the wrong position. So we need to animate it to the right one.
            if (this.isScrollingTo && this.latestTargetId) {
                this.scrollTo(this.latestTargetId);
                this.latestTargetId = undefined;
            }
        }
    };
    ScrollController.prototype.createScrollbars = function () {
        var _this = this;
        var container;
        if (this.container instanceof Window) {
            container = document.body;
        }
        else {
            container = this.container;
        }
        this.scrollbar = Scrollbar.init(container, {
            damping: 0.05,
        });
        this.addScrollbarListener(function () {
            _this.scenes.forEach(function (scene) { return scene.refresh(); });
        });
        this.controller.scrollbar = this.scrollbar;
    };
    ScrollController.prototype.removeScrollbars = function () {
        var _this = this;
        if (this.scrollbar) {
            this.scrollbarListeners.forEach(function (listener) { return _this.scrollbar.removeListener(listener); });
            this.scrollbarListeners = [];
            this.scrollbar.destroy();
        }
    };
    ScrollController.prototype.addAllScenes = function () {
        var _this = this;
        this.scenes.forEach(function (scene) { return scene.addTo(_this); });
    };
    ScrollController.prototype.removeAllScenes = function () {
        this.scenes.forEach(function (scene) { return scene.remove(); });
    };
    ScrollController.prototype.destroyController = function () {
        if (this.controller) {
            if (this.smoothScrolling) {
                console.debug("[Controller] Removed smooth scrolling");
            }
            else {
                console.debug("[Controller] Removed common scrolling");
            }
            this.controller.destroy(true);
        }
        return null;
    };
    return ScrollController;
}());
export default ScrollController;
//# sourceMappingURL=scroll-controller.js.map